<mat-toolbar>
  <mat-icon mat-list-icon>notifications</mat-icon>
  <span class="container-fluid">
    <h1>
      {{ 'ORDER_DETAILS.BUTTONS.MOBILE_NOTIFICATION' | transloco }}
    </h1>
  </span>
</mat-toolbar>

@if (isLoading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<mat-dialog-content class="mt-3">
  <form [formGroup]="form" (ngSubmit)="sendNotification()">
    @if (orderId) {
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'MOBILE_NOTIFICATION.TYPE' | transloco }}</mat-label>
        <mat-select formControlName="type">
          @for (type of typeOptions; track type) {
            <mat-option [value]="type.value">
              {{ type.viewValue }}
              <!-- {{ type.translation | transloco }} -->
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{ 'MOBILE_NOTIFICATION.TITLE' | transloco }}</mat-label>
      <input matInput formControlName="title" >
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{ 'MOBILE_NOTIFICATION.MESSAGE' | transloco }}</mat-label>
      <input matInput formControlName="message" >
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{ 'MOBILE_NOTIFICATION.PAYLOAD' | transloco }}</mat-label>
      <textarea matInput formControlName="payload"></textarea>
    </mat-form-field>

  </form>
</mat-dialog-content>

<mat-dialog-actions class="pe-4 py-3" align="end">
  <button mat-button mat-dialog-close>{{ 'PRICING.FORM.CANCEL' | transloco }}</button>
  <button mat-button color="primary" type="submit" (click)="sendNotification()">
    {{ 'MOBILE_NOTIFICATION.SEND' | transloco }}
  </button>
</mat-dialog-actions>

